"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  APP_USERS_TEAMS: 'APP_USERS_TEAMS',
  COMPANY: 'COMPANY',
  COMPANY_ASSOCIATED_OPEN_DEALS: 'COMPANY_ASSOCIATED_OPEN_DEALS',
  COMPANY_ASSOCIATED_OPEN_TICKETS: 'COMPANY_ASSOCIATED_OPEN_TICKETS',
  COMPANY_ASSOCIATIONS_FIRST_PAGE: 'COMPANY_ASSOCIATIONS_FIRST_PAGE',
  COMPANY_CHILDREN: 'COMPANY_CHILDREN',
  COMPANY_FOLLOWERS: 'COMPANY_FOLLOWERS',
  COMPANY_VIDS: 'COMPANY_VIDS',
  CONTACT: 'CONTACT',
  CONTACT_ASSOCIATED_OPEN_DEALS: 'CONTACT_ASSOCIATED_OPEN_DEALS',
  CONTACT_ASSOCIATED_OPEN_TICKETS: 'CONTACT_ASSOCIATED_OPEN_TICKETS',
  CONTACT_ASSOCIATIONS_FIRST_PAGE: 'CONTACT_ASSOCIATIONS_FIRST_PAGE',
  CONTACT_EMAIL_CAN_UNBOUNCE: 'CONTACT_EMAIL_CAN_UNBOUNCE',
  CONTACT_FOLLOWERS: 'CONTACT_FOLLOWERS',
  CONTACT_SEQUENCES_ENROLLMENT_STATE: 'CONTACT_SEQUENCES_ENROLLMENT_STATE',
  DEAL: 'DEAL',
  DEAL_ASSOCIATIONS_FIRST_PAGE: 'DEAL_ASSOCIATIONS_FIRST_PAGE',
  DEAL_FOLLOWERS: 'DEAL_FOLLOWERS',
  DEAL_PIPELINES: 'DEAL_PIPELINES',
  ENGAGEMENT_QUEUES: 'ENGAGEMENT_QUEUES',
  FAVORITE_COMPANY_PROPERTIES: 'FAVORITE_COMPANY_PROPERTIES',
  FAVORITE_COMPANY_VIEW_IDS: 'FAVORITE_COMPANY_VIEW_IDS',
  FAVORITE_CONTACT_PROPERTIES: 'FAVORITE_CONTACT_PROPERTIES',
  FAVORITE_CONTACT_VIEW_IDS: 'FAVORITE_CONTACT_VIEW_IDS',
  FAVORITE_DEAL_PROPERTIES: 'FAVORITE_DEAL_PROPERTIES',
  FAVORITE_DEAL_VIEW_IDS: 'FAVORITE_DEAL_VIEW_IDS',
  FAVORITE_TICKET_PROPERTIES: 'FAVORITE_TICKET_PROPERTIES',
  FAVORITE_DEFAULT_COMPANY_PROPERTIES: 'FAVORITE_DEFAULT_COMPANY_PROPERTIES',
  FAVORITE_DEFAULT_CONTACT_PROPERTIES: 'FAVORITE_DEFAULT_CONTACT_PROPERTIES',
  FAVORITE_DEFAULT_DEAL_PROPERTIES: 'FAVORITE_DEFAULT_DEAL_PROPERTIES',
  FAVORITE_DEFAULT_TICKET_PROPERTIES: 'FAVORITE_DEFAULT_TICKET_PROPERTIES',
  GROUPED_COMPANY_PROPERTIES: 'GROUPED_COMPANY_PROPERTIES',
  GROUPED_CONTACT_PROPERTIES: 'GROUPED_CONTACT_PROPERTIES',
  GROUPED_DEAL_PROPERTIES: 'GROUPED_DEAL_PROPERTIES',
  GROUPED_TICKET_PROPERTIES: 'GROUPED_TICKET_PROPERTIES',
  MINKOWSKI: 'MINKOWSKI',
  PINNED_COMPANY_ENGAGEMENT: 'PINNED_COMPANY_ENGAGEMENT',
  PINNED_CONTACT_ENGAGEMENT: 'PINNED_CONTACT_ENGAGEMENT',
  PINNED_DEAL_ENGAGEMENT: 'PINNED_DEAL_ENGAGEMENT',
  PINNED_TICKET_ENGAGEMENT: 'PINNED_TICKET_ENGAGEMENT',
  PORTAL_DOUBLE_OPT_IN_SETTINGS_SUMMARY: 'PORTAL_DOUBLE_OPT_IN_SETTINGS_SUMMARY',
  SFDC_METADATA: 'SFDC_METADATA',
  TICKET: 'TICKET',
  TICKET_ASSOCIATIONS_FIRST_PAGE: 'TICKET_ASSOCIATIONS_FIRST_PAGE',
  TICKET_FOLLOWERS: 'TICKET_FOLLOWERS',
  TICKET_PIPELINES: 'TICKET_PIPELINES' // Not yet implemented
  // CONTACT_EMAIL_SUBSCRIPTION_STATUS: 'CONTACT_EMAIL_SUBSCRIPTION_STATUS',
  // CONTACT_VIEWS: 'CONTACT_VIEWS',
  // COMPANY_VIEWS: 'COMPANY_VIEWS',
  // DEAL_VIEWS: 'DEAL_VIEWS',

};
exports.default = _default;
module.exports = exports.default;